module.exports = __webpack_public_path__ + "static/img/8.0cd246a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/zh/8.png
// module id = sTRa
// module chunks = 0